var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "header-marcar_consulta bg-gradient-primary"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "3"
    }
  }, [_c('h1', [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "SearchIcon",
      "size": "30"
    }
  }), _vm._v(" Pesquisadores ")], 1)]), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.fetchResearchers.apply(null, arguments);
      }
    }
  }, [_c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "SearchIcon"
    }
  })], 1), _c('b-form-input', {
    attrs: {
      "placeholder": "Buscar Pesquisador"
    },
    model: {
      value: _vm.filtro.name,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "name", $$v);
      },
      expression: "filtro.name"
    }
  })], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary button-right",
      "to": {
        name: 'PesquisadorCadastrar'
      }
    }
  }, [_vm._v(" Adicionar Pesquisador")])], 1)], 1)], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-0",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-table', {
    ref: "refResearcherListTable",
    staticClass: "position-relative",
    staticStyle: {
      "min-height": "50vw"
    },
    attrs: {
      "items": _vm.researchers,
      "responsive": "",
      "fields": _vm.tableColumns,
      "primary-key": "id",
      "show-empty": "",
      "empty-text": "Não há pesquisadores cadastrados"
    },
    scopedSlots: _vm._u([{
      key: "cell(areas)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex flex-wrap"
        }, _vm._l(data.item.areas, function (area) {
          return _c('b-badge', {
            key: area,
            staticClass: "mr-25 mb-25",
            attrs: {
              "variant": "light-primary"
            }
          }, [_vm._v(" " + _vm._s(_vm.formatArea(area)) + " ")]);
        }), 1)];
      }
    }, {
      key: "cell(active)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.item.active ? 'light-success' : 'light-danger'
          }
        }, [_vm._v(" " + _vm._s(data.item.active ? 'Ativo' : 'Inativo') + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "no-caret": "",
            "right": _vm.$store.state.appConfig.isRTL
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "align-middle text-body",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'PesquisadorEditar',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v("Editar")])], 1), _c('b-dropdown-divider'), _c('b-dropdown-item', {
          staticClass: "text-danger",
          on: {
            "click": function click($event) {
              return _vm.confirmDeletion(data.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "TrashIcon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v("Excluir")])], 1)], 1)];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }